// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_mf-0";
export var animationContainer = "_mf-1";
export var itemPrice = "_mf-a";
export var itemizedContent = "_mf-9";
export var itemizedHeader = "_mf-7";
export var itemizedRow = "_mf-8";
export var itemizedSection = "_mf-6";
export var modalContent = "_mf-2";
export var orderName = "_mf-3";
export var refundOption = "_mf-4";
export var refundOptionsContainer = "_mf-5";
export var shippingLabel = "_mf-b";
export var totalRow = "_mf-c";